var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Base-header',{staticClass:"pb-6 pb-7 bg-gradient-success"}),_c('div',{staticClass:"bg-white",attrs:{"id":"tableContainer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }